export default __webpack_public_path__ + "static/media/Home-Desktop.c850dad6.jpg";